<template>
  <el-container>
    <el-main style="padding: 0">
      <view-table
          ref="viewTable"
          :filter="filter"
          :columns-property="columnsProperty"
          module="basic"
          url="stockDetails"
          @reset="resetHandle">
        <template slot="adSearch">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
            </el-form-item>
            <el-form-item label="物料名称">
              <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
            </el-form-item>
            <el-form-item label="库位名称">
              <el-input v-model.trim="filter.locationName" placeholder="请输入库位名称" clearable/>
            </el-form-item>
            <el-form-item label="库位编号">
              <el-input v-model.trim="filter.code" placeholder="请输入库位编号" clearable/>
            </el-form-item>
          </el-form>
        </template>
      </view-table>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  export default {
    name: "InventoryList",
    components: { ViewTable },
    data() {
      return {
        filter: {
          materialNo:"",
          materialName:"",
          locationName:"",
          code:"",
        },
        columnsProperty:[
          {
            key:"materialSn",
            align:"center",
          },
          {
            key:"materialNo",
            align:"left",
            minWidth:120,
            tooltip:true,
          },
          {
            key:"materialName",
            align:"left",
            minWidth:300,
            tooltip:true,
          },
          {
            key:"locationName",
            align:"left",
            minWidth:120,
            tooltip:true,
          },
          {
            key:"quantity",
            align:"center",
            width:80,
          },
          {
            key:"materialHeight",
            align:"center",
          },
          {
            key:"materialWidth",
            align:"center",
          },
          {
            key:"unitName",
            align:"center",
          },
          {
            key:"price",
            align:"center",
          },
          {
            key:"note",
            align:"center",
          },
        ],
      };
    },
    methods:{
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
